import { render, staticRenderFns } from "./PfeilButton.vue?vue&type=template&id=3b02298f&scoped=true&"
import script from "./PfeilButton.vue?vue&type=script&lang=js&"
export * from "./PfeilButton.vue?vue&type=script&lang=js&"
import style0 from "./PfeilButton.vue?vue&type=style&index=0&id=3b02298f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b02298f",
  null
  
)

export default component.exports